import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

import firebase from 'firebase/compat/app';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthService } from '../../../core/modules/auth/services/auth.service';
import { GenericGridApiService } from '../../../core/services/grid-api-service/genericGridApi.service';
import { FileService } from '../../files/services/file.service';

import HttpsCallableResult = firebase.functions.HttpsCallableResult;

export interface JobRecord {
  customerId: string;
  type: string;
  jobId: string;
  jobName: string;
  runId: string;
  summary: string;
  start: Date;
  end: Date;
  errors?: string;
  storageLinkRef?: string;
}

export interface ListResponse {
  data: JobRecord[];
  count?: number;
  total?: number;
}

@Injectable({
  providedIn: 'root',
})
export class SyncHistoryService extends GenericGridApiService {
  public refreshRows$: Subject<void> = new Subject();
  public totalRows: BehaviorSubject<string> = new BehaviorSubject<string>('0');
  public maxRows: BehaviorSubject<string> = new BehaviorSubject<string>('0');
  public gridBusy = new BehaviorSubject<string>(null);

  constructor(
    private angularFireFunctions: AngularFireFunctions,
    protected authService: AuthService,
    private http: HttpClient,
    public fileService: FileService,
  ) {
    super(angularFireFunctions, authService, { type: 'syncHistory' });
  }

  downloadLogFile({ customerId, jobId, executionId, burstCache }): Observable<any> {
    const callable = this.angularFireFunctions.httpsCallable('jobs-downloadLogs');
    return callable({ customerId, jobId, executionId, burstCache }).pipe(
      switchMap(async (response) => {
        const url = await this.fileService.getDownloadUrlForLog(response.ref);
        // @ts-ignore
        return this.http.get<any>(url, { responseType: 'text' });
      }),
    );
  }

  setBusy(busyMessage: string): void {
    this.gridBusy.next(busyMessage);
  }
  clearBusy(): void {
    this.gridBusy.next(null);
  }

  getBusyStatus(): Observable<string | null> {
    return this.gridBusy.asObservable();
  }
}
